module.exports = __webpack_public_path__ + "img/highSpeedRail-2.9a867ee9.jpg";